module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-precomposed-095b59ff24ac9bc76c4076517c5e83dd.png";